module.exports = __webpack_public_path__ + "static/media/merck.a7aee121.png";